import api from "@src/api/api";
import SidebarCartItem from "@src/pages/marketplace/shop/SidebarCartItem";
import { setCart } from "@src/state/cart/cartSlice";
import { useAppSelector } from "@src/state/hooks";
import { Cart } from "@src/utils/cart";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";

const SideBarCart = () => {
  const { user } = useAppSelector(state => state.user);
  const { cartContent } = useAppSelector(state => state.cart);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetchCart = useCallback(async () => {
    const { data } = await api.get("/api/v1/carts");
    if (Array.isArray(data) && data.length) {
      console.log(data);
      dispatch(setCart(data));
    }
  }, [dispatch]);

  useEffect(() => {
    fetchCart();
  }, [fetchCart]);

  return (
    <>
      <div className="grid grid-flow-row text-center">
        <div className="text-sm">{t("main.shop.price.subtotal")}</div>
        <div className="font-semibold ">
          {cartContent.length > 0
            ? cartContent
                .map(item => item.quantity * (item.price_gross / 100))
                .reduce((sum, amount) => sum + amount)
                .toFixed(2)
            : 0}
          €
        </div>
      </div>
      <div className="w-full border-b border-gray-300 px-2 pb-3 pt-1">
        <NavLink
          className="flex w-full justify-center rounded-lg border border-gray-300 px-2 text-mini"
          to="/marketplace/warenkorb"
        >
          {t("main.shop.buttons.goToCart")}
        </NavLink>
      </div>
      <div className="flex flex-row">
        <div className="h-[90vh]  overflow-y-scroll">
          {cartContent.map((item: Cart, index: number) => (
            <SidebarCartItem item={item} key={index} />
          ))}
        </div>
      </div>
    </>
  );
};

export default SideBarCart;
